let testService;

if (process.env.NODE_ENV == 'test') {
    testService = require('./testService');
}

export default testService;